import React from "react";
import { Link } from "react-router-dom";

const aboutData = {
  cvpath: "media/CV.pdf",
  image: "images/me.jpg",
  name: "Lutfi Riani",
  location: "Bogor, Indonesian",
  linkedIn: "//www.linkedin.com/in/lutfi-riani",
  email: "lutfiriani1510@gmail.com",
  aboutMe: `A fresh graduate in Software Engineering with a strong interest in Data Analytics. Skilled in data entry, data collection, cleaning, processing, analysis, reporting, and visualization to transform raw data into meaningful insights. Experienced in using Microsoft Excel, SQL, Python, Power BI, and Tableau to organize and analyze data, prepare reports, and support data-driven decision-making. Detail-oriented with a strong focus on data accuracy, consistency, and documentation.`,
};

function About() {
  return (
    <div className="row align-items-start about-section">
      <div className="col-lg-4 col-md-5 mb-4 mb-md-0">
        <div className="about-thumb rounded shadow-dark mb-4">
          <img src={aboutData.image} alt={aboutData.name} />
        </div>
      </div>
      <div className="col-lg-8 col-md-7">
        <div className="about-content">
          <h2 className="mt-0 mb-4">
            Hello, I&apos;m <span>{aboutData.name}</span>
          </h2>

          <p className="about-description mb-4">{aboutData.aboutMe}</p>

          <div className="about-info-grid mb-4">
            <div className="about-card">
              <span>Name</span>
              <strong>{aboutData.name}</strong>
            </div>
            <div className="about-card">
              <span>Location</span>
              <strong>{aboutData.location}</strong>
            </div>
            <div className="about-contact-card">
              <span>LinkedIn</span>
              <a
                href={aboutData.linkedIn}
                target="_blank"
                rel="noopener noreferrer"
              >
                {aboutData.linkedIn}
              </a>
            </div>
            <div className="about-contact-card">
              <span>Email</span>
              <a href={`mailto:${aboutData.email}`}>{aboutData.email}</a>
            </div>
          </div>

          <div className="about-buttons d-flex flex-wrap gap-3">
            <a href={aboutData.cvpath} className="btn btn-default">
              <i className="icon-cloud-download"></i>Download CV
            </a>
             <Link
              to="/contact"
              className="btn btn-border-light btn-lg"
            >
              <i className="icon-envelope"></i>
              {" "}Hire me
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
